module.exports = "<app-nav></app-nav>\n<router-outlet></router-outlet>\n\n<ng2-toasty [position]=\"'top-right'\"></ng2-toasty>"